import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';

@Component({
  selector: 'app-callback-lightspeed',
  templateUrl: './callback-lightspeed.component.html',
  styleUrls: ['./callback-lightspeed.component.scss'],
})
export class CallbackLightspeedComponent implements OnInit {
  public broadcastChannel = new BroadcastChannel('LIGHTSPEED_CHANNEL');

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
  ) {}

  ngOnInit() {
    let PartnerID = localStorage.getItem('LightspeedPartnerID');
    this.activatedRoute.queryParams.subscribe((params) => {
      var data = {
        ID: parseInt(PartnerID),
        PhoneNumber1: params['code'],
      };
      this.posIntegrationService.registerLightspeed(data).subscribe(
        (result) => {
          this.broadcastChannel.postMessage('CONNECTED');
          setTimeout(() => {
            window.close();
          }, 500);
        },
        (err) => {
          this.broadcastChannel.postMessage('NOT_CONNECTED');
          window.close();
        },
      );
    });
  }
}
